import { useState } from 'react';
import QueriesTable from './QueriesTable';
import IssuesTable from './IssuesTable';

const DetailedView = ({
	hotelId
}: {
	hotelId: string
}) => {
		const [isActiveTab, setIsActiveTab] = useState<'queries' | 'issues'>('queries');
		const handleTabSelect = (tab: 'queries' | 'issues') => setIsActiveTab(tab);

	
	return (
		<div className="my-4">
			<h3 className="text-lg md:text-xl font-semibold mb-2">Drill to Details</h3>
			<div className="w-full bg-gray-100 dark:bg-black p-1.5 rounded-3xl">
                    <button
                        type="button"
                        className={`w-full md:w-6/12 text-center p-1.5 rounded-3xl ${
                            isActiveTab === 'queries' ? 'bg-gray-800' : ''
                        }`.trim()}
                        onClick={() => handleTabSelect('queries')}>
                        <span
                            className={
                                isActiveTab === 'queries'
                                    ? 'text-white'
                                    : 'text-gray-700'
                            }>
                            Queries
                        </span>
                    </button>
                    <button
                        type="button"
                        className={`w-full md:w-6/12 text-center p-1.5 rounded-3xl ${
                            isActiveTab === 'issues' ? 'bg-gray-800' : ''
                        }`.trim()}
                        onClick={() => handleTabSelect('issues')}>
                        <span
                            className={
                                isActiveTab === 'issues'
                                    ? 'text-white'
                                    : 'text-gray-700'
                            }>
                            Issues
                        </span>
                    </button>
                </div>
				{isActiveTab === 'issues' ? <IssuesTable hotelId={hotelId} /> : <QueriesTable hotelId={hotelId} />}
		</div>
	)
}

export default DetailedView;